import { Box, DashboardModule, LineChart } from '@domain-group/suit-theme'

import useChartData from '@hooks/useChartData'

import { TaskListModel } from '@models/types'

type ProjectBurnDownChartProps = {
  taskList: TaskListModel,
}

const ProjectBurnDownChart = (props: ProjectBurnDownChartProps) => {
  const { taskList } = props

  const chartDataPayload = useChartData('template_project_burn_down', {
    entityId: taskList.id,
    entityType: 'TaskList',
    excludedDataKeys: ['name'],
    dataKeyProps: {
      remaining_tasks_count: { dot: false },
      required_trend: { connectNulls: true, dot: false },
      projected_trend: { connectNulls: true, dot: false, strokeDasharray: '4 4' },
    },
  })

  const { dataArray, loading } = chartDataPayload

  return (
    <DashboardModule loading={loading} title="Project Burn Down">
      {!loading && !!dataArray.length && (
        <Box flexDirection="column" flexWrap="wrap" padding="medium">
          <LineChart dataPayload={chartDataPayload} />
        </Box>
      )}
    </DashboardModule>
  )
}

export default ProjectBurnDownChart
